import React from 'react';

export default (props) => {
    return (
        <div style={{marginLeft: 100}}>
            <h2>Analytics</h2>
        </div>
    )
}
